import { routes as auth } from "@/modules/auth";
import { routes as acl } from "@/modules/acl";
import { routes as config } from "@/modules/config";
import { routes as users } from "@/modules/users";
import { routes as areas } from "@/modules/areas";
import { routes as categorias } from "@/modules/categorias";
import { routes as estados } from "@/modules/estados";
import { routes as municipios } from "@/modules/municipios";
import { routes as tipos_instrumentos } from "@/modules/tipos_instrumentos";
import { routes as tipos_concedentes } from "@/modules/tipos_concedentes";
import { routes as tipos_instituicoes } from "@/modules/tipos_instituicoes";
import { routes as moedas } from "@/modules/moedas";
import { routes as relatorios } from "@/modules/relatorios";
import { routes as oportunidades } from "@/modules/oportunidades";
import { routes as parceiros } from "@/modules/parceiros";
import { routes as clientes } from "@/modules/clientes";
import { routes as planos } from "@/modules/planos";
import { routes as concedentes } from "@/modules/concedentes";
import { routes as files } from "@/modules/files";
import { routes as contrapartidas } from "@/modules/contrapartidas";
import { routes as cnpj } from "@/modules/cnpj";
import { routes as extratores } from "@/modules/extratores";
import { routes as perfis } from "@/modules/perfis";

export default [
  ...auth,
  ...acl,
  ...config,
  ...users,
  ...areas,
  ...categorias,
  ...estados,
  ...municipios,
  ...tipos_instrumentos,
  ...tipos_concedentes,
  ...tipos_instituicoes,
  ...moedas,
  ...relatorios,
  ...oportunidades,
  ...parceiros,
  ...clientes,
  ...planos,
  ...concedentes,
  ...files,
  ...contrapartidas,
  ...cnpj,
  ...extratores,
  ...perfis,
];
